"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoLibFrontendVars = void 0;
const envVars = {
    beta: {
        VIDEO_API_PATH: 'https://videobeta.streamyard.com/api',
        SOCKET_HOST: 'wss://videowsbeta.streamyard.com',
        SOCKET_HOST2: 'wss://videowsbeta2.streamyard.com',
        SOCKET_HOST_INTERNAL: 'ws://videowsbeta.streamyard.internal',
        VIDEO_ASSETS_HOST: 'https://beta.streamyard.com',
    },
    development: {
        VIDEO_API_PATH: 'https://dev.streamyard.com:17443/api',
        get SOCKET_HOST() {
            return (process.env.SOCKET_HOST_OVERRIDE || 'wss://dev.streamyard.com:16443');
        },
        get SOCKET_HOST2() {
            return (process.env.SOCKET_HOST2_OVERRIDE || 'wss://dev.streamyard.com:16443');
        },
        SOCKET_HOST_INTERNAL: 'wss://video-server:16443',
        get VIDEO_ASSETS_HOST() {
            return process.env.ASSETS_HOST_OVERRIDE || 'https://dev.streamyard.com';
        },
    },
    production: {
        VIDEO_API_PATH: 'https://video.streamyard.com/api',
        SOCKET_HOST: 'wss://videows.streamyard.com',
        SOCKET_HOST2: 'wss://videows2.streamyard.com',
        SOCKET_HOST_INTERNAL: 'ws://videows.streamyard.internal',
        VIDEO_ASSETS_HOST: 'https://streamyard.com',
    },
    staging: {
        VIDEO_API_PATH: 'https://videostaging.streamyard.com/api',
        SOCKET_HOST: 'wss://videowsstaging.streamyard.com',
        SOCKET_HOST2: 'wss://videowsstaging2.streamyard.com',
        SOCKET_HOST_INTERNAL: 'ws://videowsstaging.streamyard.internal',
        VIDEO_ASSETS_HOST: 'https://staging.streamyard.com',
    },
    'staging-eu': {
        VIDEO_API_PATH: 'https://videostagingeu.streamyard.com/api',
        SOCKET_HOST: 'wss://videowsstagingeu.streamyard.com',
        SOCKET_HOST2: 'wss://videowsstagingeu2.streamyard.com',
        SOCKET_HOST_INTERNAL: 'ws://videowsstagingeu.streamyard.internal',
        VIDEO_ASSETS_HOST: 'https://stagingeu.streamyard.com',
    },
};
function getVideoLibFrontendVars(environment) {
    return envVars[environment];
}
exports.getVideoLibFrontendVars = getVideoLibFrontendVars;
//# sourceMappingURL=constantsPerEnvironment.js.map